import type {PropsWithChildren} from 'react'
import {createContext, useContext, useMemo} from 'react'

type Experiments = {
  withAppMenu?: boolean
}

const ExperimentsContext = createContext<Experiments>({})

export const ExperimentsProvider = ({
  children,
  experiments: {withAppMenu},
}: PropsWithChildren<{experiments: Experiments}>) => {
  const value = useMemo(
    () => ({
      withAppMenu,
    }),
    [withAppMenu],
  )
  return <ExperimentsContext.Provider value={value}>{children}</ExperimentsContext.Provider>
}

export const useExperiments = () => {
  const context = useContext(ExperimentsContext)

  if (!context) {
    throw new Error('useExperiments must be used within a ExperimentsProvider')
  }

  return context
}
